import { render } from "./GuideBlock.vue?vue&type=template&id=f3c45bfa"
import script from "./GuideBlock.vue?vue&type=script&lang=js"
export * from "./GuideBlock.vue?vue&type=script&lang=js"

import "./GuideBlock.vue?vue&type=style&index=0&id=f3c45bfa&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__